import { HttpResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import { AuthService } from "../auth.service";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  resetForm: FormGroup;
  formSubmitted: boolean = false;
  isLoading: boolean = false;
  show: boolean = false;
  isLogin: boolean = true;
  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  message: string = "";
  type: string = "0";
  token = "";
  constructor(
    private fb: FormBuilder,
    private authServices: AuthService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {}

  projectDetail: any;
  userData = "";
  ngOnInit() {
    this.initialiseForms();
    localStorage.clear();
  }
  password() {
    this.show = !this.show;
  }
  initialiseForms() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required, Validators.minLength(8)]],
    });
  }

  login() {
    this.formSubmitted = true;
    let req = {
      email: this.loginForm.controls["email"].value,
      password: this.loginForm.controls["password"].value,
    };
    this.isLoading = true;
    this.authServices.validateLogin(req).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          localStorage.setItem("userData", JSON.stringify(res["data"]));
          localStorage.setItem("token", res["data"]["accessToken"]);
          localStorage.setItem("role", JSON.stringify(res["data"]["role"]));
          if (res["data"]["role"] == "admin" || res["data"]["role"] == "school") {
            localStorage.setItem("activeIndex", "0");
            this.router.navigate(["main/dashboard"]);
          } else {
            localStorage.setItem("activeIndex", "0");
            this.router.navigate(["main/scholarship"]);
          }
        } else {
        }
      },
      (err) => {
        this._snackBar.open(err.error?.data?.message, "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["failure"],
        });
        this.isLoading = false;
      }
    );
  }
}
